import { EditorState } from 'prosemirror-state'
import { NodeType } from 'prosemirror-model'

export const selectionContainsListType = (
  state: EditorState,
  listType: NodeType,
): { contains: boolean; exclusive: boolean } => {
  const {
    doc,
    selection: { ranges },
  } = state
  let foundNode = false
  let exclusive = true

  for (let {
    $from: { pos: from },
    $to: { pos: to },
  } of ranges) {
    doc.nodesBetween(from, to, (node) => {
      if (node.type === listType) {
        foundNode = true

        return false
      } else if (!node.isLeaf) {
        exclusive = false

        return true
      }

      return true
    })
  }

  return { contains: foundNode, exclusive }
}
